/**
 * DisplayItem > Embed object.
 *
 * @typedef {Object} Embed
 * @namespace
 *
 * @memberof Common.Model.Entity.DisplayItem
 *
 * @property {String} isEmbed Boolean indicating if the content can be embedded.
 * @property {String} embedType Unknown!
 */
class Embed {

	constructor(isEmbed, embedType) {

		this.isEmbed	= isEmbed;
		this.embedType	= embedType;
	}
}

export default Embed;